import {
  type ReactNode,
} from 'react'

import { useAuth } from '@/hooks'

import { AuthContext } from './authContext'

export interface AuthProviderProps {
  children: ReactNode
  autoRefresh?: boolean
}

/**
 * AuthProvider manages authentication state and provides token access
 * to all child components through React Context.
 */
export function AuthProvider({ children, autoRefresh = true }: AuthProviderProps) {
  const auth = useAuth({ autoRefresh })

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  )
}
